module.exports = __webpack_public_path__ + "static/media/chat-warning.f24ac00d.svg";